import { Company } from '../models/company';
import { SimManagementError } from '../models/Errors';
import {
  ENSURE_SELECTED_COMPANY,
  LOAD_SELECTED_COMPANY,
  LOAD_SELECTED_COMPANY_FAILURE,
  LOAD_SELECTED_COMPANY_SUCCESS,
} from './actionTypes';
import { Action, ActionMeta } from './commonActions';

/**
 * Action which ensures that the selected company is loaded and will fetch from server if it is not.
 * @param id
 */
export function ensureSelectedCompany(id: number): Action<number> {
  return {
    type: ENSURE_SELECTED_COMPANY,
    payload: id,
  };
}

/**
 * Action which loads the selected company from the server.
 * @param id The company identifier.
 */
export function loadSelectedCompany(id: number): Action<number> {
  return {
    type: LOAD_SELECTED_COMPANY,
    payload: id,
  };
}

/**
 * Action which handles when the selected company is successfully loaded.
 * @param company The company.
 */
export function loadSelectedCompanySuccess(company: Company) {
  return {
    type: LOAD_SELECTED_COMPANY_SUCCESS,
    payload: company,
  };
}

/**
 * Action which handles when there is a failure to load the selected company.
 * @param id The company identifier.
 * @param error The error.
 */
export function loadSelectedCompanyFailure(
  id: number,
  error: SimManagementError,
): ActionMeta<SimManagementError, number> {
  return {
    error: true,
    type: LOAD_SELECTED_COMPANY_FAILURE,
    payload: error,
    meta: id,
  };
}
